module.exports = __webpack_public_path__ + "screen1.png?acbd65f46f8f261f82eba2ace636dd49";